import { render, staticRenderFns } from "./managerLayout.vue?vue&type=template&id=23b200e9&scoped=true&"
import script from "./managerLayout.vue?vue&type=script&lang=js&"
export * from "./managerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b200e9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheManagerSideNav: require('/Users/yghee/IdeaProjects/kcc_kccam/frontend/components/kccam/manager/sideNav/TheManagerSideNav.vue').default})
